module.exports = __webpack_public_path__ + "static/media/mapView.c19dd6b4.png";